export function getdata() {
	var obj = {
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
		headData: [{
				title: "姓名",
				prop: "xingm",
				width: "100",
				custom: true,
			},
			{
				title: "国籍（地区）",
				prop: "guoj",
				width: "160",
				custom: true,
			},
			{
				title: "证件类型",
				prop: "zhengjlx",
				width: "160",
				custom: true,
			},
			{
				title: "证件号码",
				prop: "zhengjhm",
				width: "170",
				custom: true,
			},
			{
				title: "自然人纳税人识别号",
				prop: "zirrnsrsbh",
				width: "160",
				custom: true,
			}, {
				title: "操作",
				prop: "cz",
				width: "100",
				custom: true,
				align: "center"
			},
		],
		options: [{
			value: '中华人民共和国',
			label: '中华人民共和国'
		}, {
			value: '中国台湾',
			label: '中国台湾'
		}, {
			value: '中国香港特别行政区',
			label: '中国香港特别行政区'
		}, {
			value: '中国澳门特别行政区',
			label: '中国澳门特别行政区'
		}],
		zhengjlx: [{
			value: '4',
			label: '居民身份证'
		}, {
			value: '0',
			label: '组织机构代码'
		}, {
			value: '1',
			label: '营业执照'
		}, {
			value: '2',
			label: '税务登记证'
		}, {
			value: '3',
			label: '其他单位证件'
		}],
	}
	return obj
}
